var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 flex flex-wrap justify-content-end align-items-center"},_vm._l((_vm.options),function(option){return _c('span',{key:option.value,class:[
      'mr-1 mb-2 px-2 py-1 rounded cursor-pointer',
      {
        'bg-selected text-white text-20': option.value === _vm.selectedLang,
        'bg-white': option.value !== _vm.selectedLang,
      } ],on:{"click":function($event){_vm.selectedLang = option.value}}},[_vm._v(" "+_vm._s(_vm.getFlagEmoji(option.value))+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }